<template>
  <div class="title-menu-box" :style="{
    width:styleCss.width,
    padding:styleCss.padding,
    backgroundColor:styleCss.bgColor
  }">
    <div class="flex-center">
      <span class="pointer" @click="toUrl(menuObj.path1)">
        {{menuObj.title1}}
        <img
          v-if="$path==menuObj.path1"
          class="active-dog"
          src="@/assets/imgs/press-center/yuan-bg.webp"
          alt=""
        />
      </span>
      <div class="line"></div>
      <span class="pointer" @click="toUrl(menuObj.path2)">
        {{menuObj.title2}}
        <img
          v-if="$path==menuObj.path2"
          class="active-dog"
          src="@/assets/imgs/press-center/yuan-bg.webp"
          alt=""
        />
      </span>
      <div class="line"></div>
      <span class="pointer" @click="toUrl(menuObj.path3)">
        {{menuObj.title3}}
        <img
          v-if="$path==menuObj.path3"
          class="active-dog"
          src="@/assets/imgs/press-center/yuan-bg.webp"
          alt=""
        />
      </span>
      <div class="line" v-if="menuObj.path4"></div>
      <span class="pointer" @click="toUrl(menuObj.path4)" v-if="menuObj.path4">
        {{menuObj.title4}}
        <img
          v-if="$path==menuObj.path4"
          class="active-dog"
          src="@/assets/imgs/press-center/yuan-bg.webp"
          alt=""
        />
      </span>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        menuObj:{
            type:Object,
            default:{}
        },
        styleCss:{
          type:Object,
          default:{
            width:'13.2rem',
            padding:'0 2.14rem',
            bgColor:'#FFFFFF'
          }
        }
    },
  data() {
    return {
    };
  },
  mounted() {
    window.that = this;
  },
  methods: {
    toUrl(path) {
      that.$router.push(
        {
          path,
        },
        () => {}
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.title-menu-box {
  position: relative;
  margin-top: 0.22rem;
  padding: 0 2.6rem;
  padding-top: 0.29rem !important;
  width: 13.2rem;
  height: 1rem;
  box-sizing: border-box;
  background: #ffffff;
  .flex-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .line {
    width: 0.27rem;
    height: 0.02rem;
    background: #ef0000;
  }
  span {
    position: relative;
    font-size: 0.24rem;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: #000000;
    line-height: 0.23rem;
    .active-dog {
      position: absolute;
      top: -0.04rem;
      right: -0.04rem;
      width: 0.14rem;
      height: 0.14rem;
    }
  }
}
</style>